import { useEffect, useRef, useState } from "react";

let socket = null;
let attempts = 0;
let timer = null;
let status = "off";
const listeners = new Set();
const statusListeners = new Set();

function setStatus(s) {
  status = s;
  statusListeners.forEach((f) => f(s));
}

function connect() {
  const token = localStorage.getItem("practitality_token");
  if (!token || socket || !listeners.size) return;
  const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
  const ws = new WebSocket(`${base}/api/ws?token=${encodeURIComponent(token)}`);
  let pinger = null;
  socket = ws;
  setStatus("connecting");
  ws.onopen = () => {
    if (socket !== ws) { ws.close(); return; }
    attempts = 0;
    setStatus("live");
    pinger = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000);
  };
  ws.onmessage = (e) => {
    if (socket !== ws || e.data === "pong") return;
    let msg;
    try { msg = JSON.parse(e.data); } catch { return; }
    listeners.forEach((f) => f(msg));
  };
  ws.onclose = () => {
    clearInterval(pinger);
    if (socket !== ws) return;
    socket = null;
    setStatus("off");
    if (listeners.size) timer = setTimeout(connect, Math.min(30000, 1000 * 2 ** attempts++));
  };
  ws.onerror = () => ws.close();
}

function teardown() {
  clearTimeout(timer);
  const s = socket;
  socket = null;
  if (s) {
    s.onclose = null;
    s.onmessage = null;
    s.close();
  }
  setStatus("off");
}

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && listeners.size && !socket) connect();
  });
}

export function useRealtime(onEvent) {
  const ref = useRef(onEvent);
  ref.current = onEvent;
  const [st, setSt] = useState(status);
  useEffect(() => {
    const fn = (m) => ref.current && ref.current(m);
    listeners.add(fn);
    statusListeners.add(setSt);
    connect();
    return () => {
      listeners.delete(fn);
      statusListeners.delete(setSt);
      if (!listeners.size) teardown();
    };
  }, []);
  return st;
}
